import { render } from "./Other.vue?vue&type=template&id=159e5862"
import script from "./Other.vue?vue&type=script&lang=js"
export * from "./Other.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/Icons/Other.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "159e5862"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('159e5862', __exports__)) {
    api.reload('159e5862', __exports__)
  }
  
  module.hot.accept("./Other.vue?vue&type=template&id=159e5862", () => {
    api.rerender('159e5862', render)
  })

}


export default __exports__